<mat-toolbar color="primary"  role="heading">
  <button id="nav_menu" mat-icon-button (click)="drawer.toggle()">
    <mat-icon>menu</mat-icon>
  </button>

  <a id="logo" [routerLink]="['']" class="link">
    <img src="/assets/img/logo_top_bar.png" alt="logo"/>
  </a>
  <span class="spacer"></span>
  <span id="app-version">v{{currentApplicationVersion}}<span id="release-stage">&nbsp;beta</span></span>
  <button mat-icon-button [matMenuTriggerFor]="userMenu">
    <mat-icon>settings</mat-icon>
  </button>
  <mat-menu #userMenu="matMenu" yPosition="below">
    <a mat-menu-item [routerLink]="['company']" *appCurrentCompanyRight="{domain: 'COMPANY', right: 'READ'}">
      <mat-icon>corporate_fare</mat-icon>
      <span>Mon organisation</span></a>
    <a mat-menu-item [routerLink]="['/auth/update-password']">
      <mat-icon>password</mat-icon>
      <span>Mettre à jour mon mot de passe</span></a>
    <button mat-menu-item (click)="signOut()">
      <mat-icon>logout</mat-icon>
      <span>Me déconnecter</span></button>
  </mat-menu>
</mat-toolbar>

<mat-drawer-container id="sidenav">

  
  <mat-drawer #drawer mode="side" opened>
    <div class="side-menu">
      <ng-container>
        <a
          [routerLink]="['welcome']"
          [routerLinkActive]="['active-link']"
          class="side-menu_item">
                <mat-icon color="light">home</mat-icon>
          <span class="side-menu_label">
            Accueil
          </span>
        </a>
        <span class="side-menu_divider"></span>
      </ng-container>

      <ng-container *appCurrentCompanyRight="{domain: 'FOLDER', right: 'READ'}">
        <a
          [routerLink]="['folders']"
          [routerLinkActive]="['active-link']"
          class="side-menu_item"
          *appCurrentCompanyRight="{domain: 'FOLDER', right: 'READ'}"
          >
                <mat-icon color="light">folder</mat-icon>
          <span class="side-menu_label">
            Dossiers comptables
          </span>
        </a>
        <span class="side-menu_divider"></span>
      </ng-container>


      <ng-container *appCurrentCompanyRights="[{domain: 'CONNECTOR', right: 'READ'}, {domain: 'STANDALONE_CONNECTOR_TOOL', right: 'EXECUTE'}, {domain: 'TRANSFER_TOOL', right: 'READ'}]">
       <a
          [routerLink]="['third-parts']"
          [routerLinkActive]="['active-link']"
          class="side-menu_item"
          *appCurrentCompanyRight="{domain: 'CONNECTOR', right: 'READ'}"
          >
                <mat-icon color="light">key</mat-icon>
          <span class="side-menu_label">
            Clés API
          </span>
        </a>
        <span class="side-menu_divider"></span>
      </ng-container>


      <ng-container *appCurrentCompanyRights="[{domain: 'STANDALONE_TOOL', right: 'EXECUTE'}, {domain: 'STANDALONE_CONNECTOR_TOOL', right: 'EXECUTE'}]">
        <a
          [routerLink]="['tools/fec-verifier']"
          [routerLinkActive]="['active-link']"
          class="side-menu_item"
          *appCurrentCompanyRight="{domain: 'STANDALONE_TOOL', right: 'EXECUTE'}"
          >
          <mat-icon color="light">checklist</mat-icon>
          <span class="side-menu_label">
            Vérificateur de FEC
          </span>
        </a>
        <a
          [routerLink]="['tools/extract-accounting-assets']"
          [routerLinkActive]="['active-link']"
          class="side-menu_item"
          *appCurrentCompanyRight="{domain: 'STANDALONE_TOOL', right: 'EXECUTE'}"
          >
          <mat-icon color="light">download</mat-icon>
          <span class="side-menu_label">
            Extraction d'immobilisations
          </span>
        </a>
        <a
          [routerLink]="['tools/extract-tra-accounting-folder']"
          [routerLinkActive]="['active-link']"
          class="side-menu_item"
          *appCurrentCompanyRight="{domain: 'STANDALONE_TOOL', right: 'EXECUTE'}"
          >
          <mat-icon color="light">download</mat-icon>
          <span class="side-menu_label">
            Extraction .TRA CEGID
          </span>
        </a>
        <a
          [routerLink]="['tools/extract-ascii-fec']"
          [routerLinkActive]="['active-link']"
          class="side-menu_item"
          *appCurrentCompanyRight="{domain: 'STANDALONE_TOOL', right: 'EXECUTE'}"
          >
          <mat-icon color="light">download</mat-icon>
          <span class="side-menu_label">
            Conversion .ASCII vers FEC
          </span>
        </a>
        <a
          [routerLink]="['tools/extract-accounting-entries/api']"
          [routerLinkActive]="['active-link']"
          class="side-menu_item"
          *appCurrentCompanyRight="{domain: 'STANDALONE_CONNECTOR_TOOL', right: 'EXECUTE'}"
          >
          <mat-icon color="light">download</mat-icon>
          <span class="side-menu_label">
            Extraction d'écritures (API)
          </span>
        </a>
        <a
          [routerLink]="['tools/extract-accounting-entries/file']"
          [routerLinkActive]="['active-link']"
          class="side-menu_item"
          *appCurrentCompanyRight="{domain: 'STANDALONE_CONNECTOR_TOOL', right: 'EXECUTE'}"
          >
          <mat-icon color="light">download</mat-icon>
          <span class="side-menu_label">
            Extraction d'écritures (FICHIER)
          </span>
        </a>
        <span class="side-menu_divider"></span>
          <a
            [routerLink]="['tools/pdf-tool-box']"
            [routerLinkActive]="['active-link']"
            class="side-menu_item"
            *appCurrentCompanyRight="{domain: 'STANDALONE_CONNECTOR_TOOL', right: 'EXECUTE'}"
            >
            <mat-icon color="light">download</mat-icon>
            <span class="side-menu_label">
              Outils Zip et PDF
            </span>
          </a>
        <span class="side-menu_divider"></span>
      </ng-container>
      

      <ng-container *appCurrentCompanyRight="{domain: 'TRANSFER_TOOL', right: 'READ'}">
        <a
          [routerLink]="['migration/project']"
          [routerLinkActive]="['active-link']"
          class="side-menu_item"
          *appCurrentCompanyRight="{domain: 'TRANSFER_TOOL', right: 'READ'}"
          >
          <mat-icon color="light">settings</mat-icon>
          <span class="side-menu_label">
            Projets de migration
          </span>
        </a>
        <a
          [routerLink]="['migration/folder']"
          [routerLinkActive]="['active-link']"
          class="side-menu_item"
          *appCurrentCompanyRight="{domain: 'TRANSFER_TOOL', right: 'READ'}"
          >
          <mat-icon color="light">list</mat-icon>
          <span class="side-menu_label">
            Dossiers de migration
          </span>
        </a>
        <a
          [routerLink]="['migration/upload']"
          [routerLinkActive]="['active-link']"
          class="side-menu_item"
          *appCurrentCompanyRight="{domain: 'TRANSFER_TOOL', right: 'EXECUTE'}"
          >
          <mat-icon color="light">upload_file</mat-icon>
          <span class="side-menu_label">
            Uploads
          </span>
        </a>
        <span class="side-menu_divider"></span>
      </ng-container>
      <ng-container>
      <a mat-menu-item 
      [routerLink]="['company']"
      [routerLinkActive]="['active-link']"
      class="side-menu_item"
       *appCurrentCompanyRight="{domain: 'COMPANY', right: 'READ'}">
        <mat-icon>corporate_fare</mat-icon>
        <span class="side-menu_label">Mon organisation</span>
      </a>
      <span class="side-menu_divider"></span>
      </ng-container>

      <ng-container>
        <a
          [routerLink]="['scheduling']"
          [routerLinkActive]="['active-link']"
          class="side-menu_item"
          *appFeatureFlag="'ENABLE_SCHEDULING'"
          >
          <mat-icon color="light">calendar_month</mat-icon>
          <span class="side-menu_label">
            Prendre rendez-vous
          </span>
        </a>
        <span class="side-menu_divider"></span>
      </ng-container>

      <ng-container>
        <a
          [routerLink]="['support']"
          [routerLinkActive]="['active-link']"
          class="side-menu_item"
          >
          <mat-icon color="light">contact_support</mat-icon>
          <span class="side-menu_label">
           Contacter le support
          </span>
        </a>
        <span class="side-menu_divider"></span>
      </ng-container>

      <ng-container>
        <button
          *appFeatureFlag="'ENABLE_DOCUMENTATION'"
          (click)="openDialog()"
          class="side-menu_item doc-button"
          mat-button
          >
          <mat-icon color="light">school</mat-icon>
          <span class="side-menu_label">
          Découvrir Klafuti
          </span>
        </button>
        <span class="side-menu_divider"></span>
      </ng-container>

    </div>
  </mat-drawer>

  <mat-drawer-content class="layout-content">
    <router-outlet></router-outlet>
  </mat-drawer-content>
</mat-drawer-container>

<ng-template #loading>
  <div class="loading-wrapper">
    <mat-spinner color="accent" diameter="50"></mat-spinner>
  </div>
</ng-template>
